import { SegmentCardEvent, SegmentCardOptions, segmentTrackAction } from '../../../../../../../../middlewares/segment';
import { SegmentCardSourceValue } from '../../../../../../../../middlewares/segment/trackEntities/cardEvents';
import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { IGetState, TBoardId } from '../../../../../../../../types/types';
import { saveProperties } from '../effects/saveProperties';
import {
    ICustomPropertiesElement
} from '../../../../../../base/components/CustomProperties/components/CustomProperty/types';

export const onSave = (
    boardId: TBoardId,
    elements: ICustomPropertiesElement[]
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        dispatch(segmentTrackAction(SegmentCardEvent.CUSTOM_PROPERTIES_EDIT_SAVE_CLICKED, {
            name: SegmentCardOptions.SOURCE,
            value: SegmentCardSourceValue.DETAILS
        }));
        return dispatch(saveProperties(boardId, elements));
    };
    return action;
};
